import { JobObjectStageStatus, JobObjectStatus, JobStatus } from '../interfaces/job';
import { GenericStatus, GenericStatusColorType } from '../../shared/interfaces/generic-status';

export const JOB_STATUS_DATA_MAP: { [key in JobStatus]: GenericStatus<JobStatus> } = {
  [JobStatus.IN_PROGRESS]: {
    value: JobStatus.IN_PROGRESS,
    displayName: 'In Progress',
    icon: 'testing',
    colorType: GenericStatusColorType.INFO
  },
  [JobStatus.COMPLETED]: {
    value: JobStatus.COMPLETED,
    displayName: 'Completed',
    icon: 'circle-tick',
    colorType: GenericStatusColorType.SUCCESS
  },
  [JobStatus.FAILED]: {
    value: JobStatus.FAILED,
    displayName: 'Failed',
    icon: 'error-outline',
    colorType: GenericStatusColorType.ERROR
  },
  [JobStatus.COMPLETED_WITH_FAILURES]: {
    value: JobStatus.COMPLETED_WITH_FAILURES,
    displayName: 'Completed With Failures',
    icon: 'warning',
    colorType: GenericStatusColorType.WARNING
  },
  [JobStatus.CANCELLED]: {
    value: JobStatus.CANCELLED,
    displayName: 'Cancelled',
    icon: 'close',
    colorType: GenericStatusColorType.WARNING
  },
  [JobStatus.CANCELLING]: {
    value: JobStatus.CANCELLING,
    displayName: 'Cancelling',
    icon: 'close',
    colorType: GenericStatusColorType.WARNING
  },
  [JobStatus.SKIPPED]: {
    value: JobStatus.SKIPPED,
    displayName: 'Skipped',
    icon: 'skip',
    colorType: GenericStatusColorType.DISABLED
  }
};

export const JOB_OBJECT_STAGE_STATUS_DATA_MAP: {
  [key in JobObjectStageStatus]: GenericStatus<JobObjectStageStatus>;
} = {
  [JobObjectStageStatus.IN_PROGRESS]: {
    value: JobObjectStageStatus.IN_PROGRESS,
    displayName: 'In Progress',
    icon: 'testing',
    colorType: GenericStatusColorType.INFO
  },
  [JobObjectStageStatus.COMPLETED]: {
    value: JobObjectStageStatus.COMPLETED,
    displayName: 'Completed',
    icon: 'circle-tick',
    colorType: GenericStatusColorType.SUCCESS
  },
  [JobObjectStageStatus.COMPLETED_WITH_FAILURES]: {
    value: JobObjectStageStatus.COMPLETED_WITH_FAILURES,
    displayName: 'Completed With Failures',
    icon: 'warning',
    colorType: GenericStatusColorType.WARNING
  },
  [JobObjectStageStatus.FAILED]: {
    value: JobObjectStageStatus.FAILED,
    displayName: 'Failed',
    icon: 'error-outline',
    colorType: GenericStatusColorType.ERROR
  },
  [JobObjectStageStatus.NOT_INITIALISED]: {
    value: JobObjectStageStatus.NOT_INITIALISED,
    displayName: 'Not Initialised',
    icon: 'history',
    colorType: GenericStatusColorType.DISABLED
  },
  [JobObjectStageStatus.CANCELLED]: {
    value: JobObjectStageStatus.CANCELLED,
    displayName: 'Cancelled',
    icon: 'close',
    colorType: GenericStatusColorType.WARNING
  }
};

export const JOB_OBJECT_STATUS_DATA_MAP: {
  [key in JobObjectStatus]: GenericStatus<JobObjectStatus>;
} = {
  [JobObjectStatus.IN_PROGRESS]: {
    value: JobObjectStatus.IN_PROGRESS,
    displayName: 'In Progress',
    icon: 'testing',
    colorType: GenericStatusColorType.INFO
  },
  [JobObjectStatus.COMPLETED]: {
    value: JobObjectStatus.COMPLETED,
    displayName: 'Completed',
    icon: 'circle-tick',
    colorType: GenericStatusColorType.SUCCESS
  },
  [JobObjectStatus.COMPLETED_WITH_FAILURES]: {
    value: JobObjectStatus.COMPLETED_WITH_FAILURES,
    displayName: 'Completed With Failures',
    icon: 'warning',
    colorType: GenericStatusColorType.WARNING
  },
  [JobObjectStatus.FAILED]: {
    value: JobObjectStatus.FAILED,
    displayName: 'Failed',
    icon: 'error-outline',
    colorType: GenericStatusColorType.ERROR
  },
  [JobObjectStatus.CANCELLED]: {
    value: JobObjectStatus.CANCELLED,
    displayName: 'Cancelled',
    icon: 'close',
    colorType: GenericStatusColorType.WARNING
  }
};
